module.exports = __webpack_public_path__ + "img/fptkzn.4b7bae2a.png";